import React from 'react';
export function Footer() {
  return <footer className="bg-navy py-12 px-5 w-full" data-id="element-109">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-110">
        <div className="text-2xl tracking-tight" data-id="element-111">
          <span className="text-white font-bold font-heading" data-id="element-112">Clean</span>
          <span className="text-accent-teal font-bold font-heading" data-id="element-113">AI</span>
        </div>

        <div className="text-white/50 text-sm font-body" data-id="element-114">
          &copy; 2026 CleanAI. Tutti i diritti riservati.
        </div>
      </div>
    </footer>;
}